import { HttpClient, HttpHeaders } from '@angular/common/http';
import { ConfigService } from './config.service';
import * as i0 from "@angular/core";
import * as i1 from "@angular/common/http";
import * as i2 from "./config.service";
export class IndicadoresService {
    constructor(http, configService) {
        this.http = http;
        this.configService = configService;
    }
    getIndicadoresValues(anio, zona, mes, tipo) {
        const userid = sessionStorage.getItem('userid');
        const headers = new HttpHeaders({ Authorization: sessionStorage.getItem('batoken'), User: userid });
        anio = anio === "0" ? "" : anio;
        zona = zona === "0" ? "" : zona;
        mes = mes === "0" ? "" : mes;
        tipo = tipo === "0" ? "" : tipo;
        return this.http.get(`${this.configService.API_URL}/indicadores/values?user=${userid}&anio=${anio}&zona=${zona}&mes=${mes}&tipo=${tipo}`, { headers }).toPromise();
    }
}
IndicadoresService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function IndicadoresService_Factory() { return new IndicadoresService(i0.ɵɵinject(i1.HttpClient), i0.ɵɵinject(i2.ConfigService)); }, token: IndicadoresService, providedIn: "root" });
